




















































import { Component, Vue } from 'vue-property-decorator';
import { SysConst as SC } from '@/trials/plugins/const';
import { sessionModule } from '@/trials/store/modules/session';

@Component
export default class TrainResultMenu extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private nextBtnColorBg: string = SC.Color.Button.Next.BG;
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewTrainResult;
    }

    private get enabledPredictPhase(): boolean {
        return sessionModule.getEnabledPredictPhase;
    }

    /*----------------------------------*
     * Active, Disabledフラグ
     *-----------------------------------*/
    // 全体の学習デ結果
    private get activeAll(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_RESULT_ALL);
    }
    private get disabledAll() {
        return this.activeAll;
    }

    // 個別の学習結果
    private get activeData(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_RESULT_DATA);
    }
    private get disabledData() {
        return this.activeData;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // Child コンポーネントの指定なし
        if (this.$route.path == SC.Path.TRAIN_RESULT_MENU) {
            // Child コンポーネントへのルーティング
            this.$router.replace(this.currentContent);
        }
    }
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    // コンテンツ表示
    private viewContent(content: string) {
        sessionModule.SET_ROUTE_TRAIN_RESULT(content);
        this.$router.push(this.currentContent);
    }

    /* Clickメソッド(コンテンツ切替)
        ------------------------------*/
    // 全体
    private toAll() {
        this.viewContent(SC.Path.TRAIN_RESULT_ALL);
    }

    // データ一覧
    private toData() {
        this.viewContent(SC.Path.TRAIN_RESULT_DATA);
    }

    // 予測の準備へ遷移
    private goPredictPhase() {
        sessionModule.SET_ENABLED_PREDICT_PHASE(true);
        sessionModule.SET_ROUTE_TRIALS(SC.Path.PREDICT_DATA_MENU);
        this.$router.push(sessionModule.getCurrentRouterViewTrials);
    }
}
